import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DailyCallsSlider = ({ value, onChange, min = 4, max = 100, onSave, isSaving, headerRight = null }) => {
  const { t } = useTranslation();
  const percentage = max > min ? ((value - min) / (max - min)) * 100 : 0;

  const handleChange = (e) => {
    onChange(parseInt(e?.target?.value));
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 lg:p-8">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 mb-6">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="w-10 h-10 bg-warning/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Phone" size={20} color="var(--color-warning)" />
          </div>
          <div className="min-w-0">
            <h2 className="text-lg md:text-xl font-semibold text-foreground">{t('ai.dailyMinutes.title')}</h2>
            <p className="text-sm text-muted-foreground">{t('ai.dailyMinutes.subtitle')}</p>
          </div>
        </div>
        {headerRight ? (
          <div className="w-full sm:w-64 sm:flex-shrink-0">{headerRight}</div>
        ) : null}
      </div>

      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">{t('ai.dailyMinutes.currentLimit')}</span>
          <div className="flex items-center gap-2">
            <span className="text-3xl md:text-4xl font-bold text-foreground data-text">{value}</span>
            <span className="text-sm text-muted-foreground">{t('ai.dailyMinutes.minutesPerDay')}</span>
          </div>
        </div>

        <div className="relative">
          <input
            type="range"
            min={min}
            max={max}
            value={value}
            onChange={handleChange}
            className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer"
            style={{
              background: `linear-gradient(to right, var(--color-primary) 0%, var(--color-primary) ${percentage}%, var(--color-muted) ${percentage}%, var(--color-muted) 100%)`
            }}
          />
          <div className="flex justify-between mt-2">
            <span className="text-xs text-muted-foreground">{min}</span>
            <span className="text-xs text-muted-foreground">{max}</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
          <div className="bg-muted/50 rounded-lg flex-1 min-w-0">
            <div className="flex items-start gap-2">
              <Icon name="Info" size={16} color="var(--color-accent)" className="mt-0.5 flex-shrink-0" />
              <p className="text-xs md:text-sm text-muted-foreground">
                {t('ai.dailyMinutes.hint')}
              </p>
            </div>
          </div>

          {onSave && (
            <Button
              type="button"
              variant="default"
              size="default"
              iconName="Save"
              iconPosition="left"
              loading={isSaving}
              onClick={() => onSave(value)}
              className="sm:flex-shrink-0"
            >
              {isSaving ? t('ai.dailyMinutes.saving') : t('common.save')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DailyCallsSlider;
